import React, { Component } from "react";
import { Route } from "react-router-dom";

import UploadFile from "./UploadFile";
import FileManagement from "./FileManagement/FileManagement";
import FileInfo from "./FileManagement/FileInfo";
import ReportBaselList from "./Reports/ReportBasel";
import ReportIRBList from "./Reports/ReportIRB";
import ReportSAList from "./Reports/ReportSA";
// import CapitalList from './Capitals/ReportList';

export default function CAR({ match }) {
  return (
    <div className="content">
      <div className="container-fluid">
        <Route path={`${match.url}/upload-file`} component={UploadFile} />
        <Route path={`${match.url}/report-sa`} component={ReportSAList} />
        <Route path={`${match.url}/report-irb`} component={ReportIRBList} />
        <Route path={`${match.url}/report-basel`} component={ReportBaselList} />
        {/* <Route path={`${match.url}/capitals`} component={CapitalList} /> */}
        <Route
          path={`${match.url}/file-management`}
          component={FileManagement}
        />
        <Route
          path={`${match.url}/file-info/:report_date/:file_name`}
          component={FileInfo}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/CAR/index.js